import { Injectable } from '@angular/core'

export type LoggedUserData = {
  _id: string
  nome: string
  role: number
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  getLoggedUser() {
    const token = localStorage.getItem('tokenVisio')
    return this.getUserFromToken(token)
  }

  private getUserFromToken(token: string | null): LoggedUserData | null {
    if (!token) return null

    const base64Url = token.split('.')[1]
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
        })
        .join('')
    )

    return JSON.parse(jsonPayload)
  }
}
